import {useState} from 'react'
import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {error} from 'console'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import moment from 'moment'
import {set} from 'date-fns'

export const EventsRecap = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')

  const submitData = async () => {
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      return
    }
    setError('')
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list:  server!=="all" && groupSelected ? groupSelected.value : null,
      selected_server:  server!=="all" ? serversSelected.map((srv: any) => srv.value) :[],
      tz: new Date().getTimezoneOffset(),
    }
    setFilterData(data)
  }
  let params: any = {
    title: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.TITLE'}),
    subtitle: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.SUBTITLE'}),
    yAxisTitle: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.YAXISTITLE'}),

    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
    pointFormat:
      '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:,.0f} ' + intl.formatMessage({id:"REPORT_DEVICE.EVENTS_RECAPS.TOOLTIP"}) + '.</b> <br/>',
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.chart = {type: 'pie'}
  baseChartOptions.xAxis = {type: 'category'}
  baseChartOptions.legend = {
    layout: 'vertical',

    verticalAlign: 'bottom',
   
    title: {text: ':: ' + intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.LEGEND_TITLE'})},
 
    borderWidth: 1,
    backgroundColor: '#FFFFFF',
  }
  baseChartOptions.plotOptions = {
    pie: {
        size: '100%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y:,.0f}',
            style: {
                color: 'black'
            }
        },
        showInLegend: true
    }
};
  return (
    <>
      <CrudProvider api='reports/recap'>
        <ChartsComponent
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_RECAPS.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float:"left"}}
          />{' '}
          {loading && <div className='spinner-border text-primary' role='status' style={{marginTop: '7px',float:"left",marginLeft:"10px"}}>
                <span className='visually-hidden'>Loading...</span>
              </div>}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
